import React from "react";
import { Helmet } from "react-helmet";
import styles from "../style.module.scss";
import { PageBanner } from "../../../../components/parts/section";
import { productData } from "../../../../utils/constants";
import { CommonProductPage } from "../../../../components/parts";

const ColorRolledSteel = () => {
  const singleProductData = productData.filter((val) => val.id === 11);
  return (
    <>
      <Helmet>
        <title>
          Cold Rolled Steel Bar | Cold Rolled Steel Sheet, Hex Bar, Angle
        </title>
        <meta
          name="description"
          content="APF Steel provides advanced quality cold rolled steel bars, sheet for your project requirements. Contact us for angles, steel beams, plates etc."
        />
      </Helmet>
      <div className={styles.productInnerPage}>
        <PageBanner image={singleProductData[0].featured_image} />
        <CommonProductPage
          title={singleProductData[0].name}
          description={singleProductData[0].description}
          features={singleProductData[0].product_feature}
          gallery={singleProductData[0].productGallery}
        />
      </div>
    </>
  );
};

export default ColorRolledSteel;
